import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const NotificationsIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.8 10.2C3.8 5.67126 7.47127 2 12 2C16.5287 2 20.2 5.67126 20.2 10.2V17.5936H21C21.5523 17.5936 22 18.0413 22 18.5936C22 19.1459 21.5523 19.5936 21 19.5936H15.5509C15.1236 20.9869 13.8269 22 12.2936 22H11.7064C10.1731 22 8.87638 20.9869 8.44914 19.5936H3C2.44772 19.5936 2 19.1459 2 18.5936C2 18.0413 2.44772 17.5936 3 17.5936H3.8V10.2ZM5.8 17.5936H18.2V10.2C18.2 6.77584 15.4242 4 12 4C8.57583 4 5.8 6.77583 5.8 10.2V17.5936ZM10.7175 19.5936C10.9715 19.8449 11.3209 20 11.7064 20H12.2936C12.6791 20 13.0285 19.8449 13.2825 19.5936H10.7175Z"
    fill="currentColor"
  />,
  "NotificationsIcon"
);
